



















































































































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class PizzaLoader extends Vue {
    rotates:Array<Boolean>= [
        true,
        true,
        true,
        true,
        true,
        true
    ]
    
}
